var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:[
    'requirement',
    `requirement--${_vm.status}`,
    { 'requirement--small': _vm.small },
  ]},[(_vm.withIcon)?_c('span',{staticClass:"requirement__icon"},[_c('i',{class:_vm.iconClass})]):_vm._e(),_c('span',{class:[
      'requirement__label',
      { 'invalid-feedback d-block': _vm.status === 'failed' && !_vm.withIcon },
    ]},[_vm._t("label",function(){return [_vm._v(_vm._s(_vm.label))]})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }